var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.516 25.0186C46.516 38.8013 38.7631 46.5543 24.9804 46.5543C11.1976 46.5543 3.44482 38.8013 3.44482 25.0186C3.44482 11.2358 11.1976 3.48297 24.9804 3.48297",
    stroke: "black",
    strokeWidth: 3.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5346 14.1791C16.5345 15.3138 13.7817 19.0952 13.7817 25.0175C13.7817 32.1845 17.8132 36.216 24.9803 36.216C31.1934 36.216 35.0499 33.1863 35.9668 27.7106",
    stroke: "black",
    strokeWidth: 3.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9805 25.0171L32.4439 17.5537",
    stroke: "black",
    strokeWidth: 3.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4409 17.56L31.8957 15.7919C31.1713 13.443 31.8055 10.886 33.5435 9.14788L39.2457 3.44543L40.9687 9.03202L46.5553 10.7549L40.853 16.4572C39.115 18.1954 36.558 18.8297 34.2089 18.1053L32.4409 17.56Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4409 17.56L31.8957 15.7919C31.1713 13.443 31.8055 10.886 33.5435 9.14788L39.2457 3.44543L40.9687 9.03202L46.5553 10.7549L40.853 16.4572C39.115 18.1954 36.558 18.8297 34.2089 18.1053L32.4409 17.56Z",
    stroke: "black",
    strokeWidth: 3.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalTracker);
export default __webpack_public_path__ + "static/media/goal_tracker.060ee4d7b5fb8f46873b1ffe182acde4.svg";
export { ForwardRef as ReactComponent };